<template>

  <div class="container">
    <p><img src="@/assets/Quest_long_logo.png"></p>
    <div class="card">
      <section class="hero is-primary">
        <div class="hero-body">
          <div class="container">
            <div class="level">
              <div class="level-left">
                <h1 class="title">
                  Lifestyles Discovery Migration Page
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="content is-medium">
      <p></p>

      <h1>Discovery is now Lifestyles Quest</h1>

      <h3>Quest does all of Discovery plus more — at the same price and faster.</h3>

      <h4>Complete these simple steps to move your Discovery account to Quest:</h4>

      <strong>STEP 1 - Please enter your Lifestyles Discovery username and password:</strong>
      <p>We use this information to validate your Discovery account.</p>

      <b-field label="Discovery Username">
        <input
          @focus="$event.target.select()"
          class="input"
          :class="{ 'is-danger': (!$v.username.required) && $v.username.$error }"
          placeholder="Your Lifestyles Discovery username"
          v-model.trim="$v.username.$model"
        >
      </b-field>

      <b-field label="Discovery Password">
        <input
          @focus="$event.target.select()"
          class="input"
          type="password"
          :class="{ 'is-danger': (!$v.password.required) && $v.password.$error }"
          placeholder="Your Lifestyles Discovery password"
          v-model.trim="$v.password.$model"
        >
      </b-field>

      <p>Need help? Email us at <a
          href="mailto:quest@luinc.com?subject=Help migrating to Quest&body=I'm migrating to Quest and need to know my Discovery username and password. Thank you."
          target="_blank"
        >quest@luinc.com</a> and we will lookup your Discovery username and password for you.</p>

      <p>&nbsp;</p>

      <strong>STEP 2 - Please enter your credit card information:</strong>
      <p>Why are we asking for your credit card when Discovery already has it? Lifestyles Quest uses a different billing system and we need to create your account in that system.</p>
      <p>Don't worry there's no additional cost. Your new Quest account will be charged at the same amount and date that your Discovery account was.</p>

      <div class="columns">

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.firstNameOnCard.required) && $v.firstNameOnCard.$error }"
              type="text"
              placeholder="First name on card"
              value=""
              v-model.trim="$v.firstNameOnCard.$model"
            >
          </div>
        </div>

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.lastNameOnCard.required) && $v.lastNameOnCard.$error }"
              type="text"
              placeholder="Last name on card"
              v-model.trim="$v.lastNameOnCard.$model"
            >
          </div>
        </div>

      </div>

      <div class="columns">

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.ccNumber.required || !$v.ccNumber.numeric) && $v.ccNumber.$error }"
              type="text"
              placeholder="Credit card number (no spaces)"
              v-model.trim="$v.ccNumber.$model"
            >
          </div>
        </div>

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.cvv.required || !$v.cvv.numeric) && $v.cvv.$error }"
              type="text"
              placeholder="CVV"
              value=""
              v-model.trim="$v.cvv.$model"
            >
          </div>
        </div>

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.expirationMonth.required || !$v.expirationMonth.numeric || $v.expirationMonth.minLength || $v.expirationMonth.maxLength) && $v.expirationMonth.$error }"
              type="text"
              placeholder="MM (Month)"
              value=""
              v-model.trim="$v.expirationMonth.$model"
            >
          </div>
          <div
            class="help is-danger"
            v-if="!$v.expirationMonth.numeric && !$v.cvv.$error"
          >Only numbers are allowed</div>
          <div
            class="help is-danger"
            v-if="!$v.expirationMonth.minLength && !$v.cvv.$error"
          >Must be 2 numbers long</div>
          <div
            class="help is-danger"
            v-if="!$v.expirationMonth.maxLength && !$v.cvv.$error"
          >Must be 2 numbers long</div>
        </div>

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.expirationYear.required || !$v.expirationYear.numeric || $v.expirationYear.minLength || $v.expirationMonth.maxLength) && $v.expirationYear.$error }"
              type="text"
              placeholder="YYYY (Year)"
              value=""
              v-model.trim="$v.expirationYear.$model"
            >
          </div>
          <div
            class="help is-danger"
            v-if="!$v.expirationYear.numeric && !$v.cvv.$error"
          >Only numbers are allowed</div>
          <div
            class="help is-danger"
            v-if="!$v.expirationYear.minLength && !$v.cvv.$error"
          >Must be 4 numbers long</div>
          <div
            class="help is-danger"
            v-if="!$v.expirationYear.maxLength && !$v.cvv.$error"
          >Must be 4 numbers long</div>
        </div>

      </div>

      <p>&nbsp;</p>

      <strong>STEP 3 - Start your Lifestyles Quest subscription.</strong>

      <p>&nbsp;</p>

      <div class="level level-item">
        <b-checkbox v-model="agreed">I agree to the <router-link :to="{ name: 'PrivacyPolicy'}">policies</router-link> and <router-link :to="{ name: 'TermsAndConditions'}">terms</router-link>
        </b-checkbox>
      </div>

      <div class="level">
        <div class="level-item">
          <button
            :disabled="!agreed"
            class="button is-primary is-large"
            v-on:click="migrate()"
          >Start My Lifestyles Quest Subscription</button>
        </div>
      </div>

      <div style="padding-bottom: 100px">
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric
} from "vuelidate/lib/validators";

export default {
  validations: {
    username: {
      required
    },
    password: {
      required
    },
    ccNumber: {
      required,
      numeric
    },
    firstNameOnCard: {
      required
    },
    lastNameOnCard: {
      required
    },
    expirationMonth: {
      required,
      numeric,
      minLength: minLength(2),
      maxLength: maxLength(2)
    },
    expirationYear: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4)
    },
    cvv: {
      required,
      numeric
    }
  },

  data() {
    return {
      username: "",
      password: "",
      ccNumber: "",
      firstNameOnCard: "",
      lastNameOnCard: "",
      expirationMonth: "",
      expirationYear: "",
      cvv: "",
      agreed: false
    };
  },

  methods: {
    async migrate() {
      console.log(
        "migrate()",
        this.username,
        this.password,
        this.ccNumber,
        this.firstNameOnCard,
        this.lastNameOnCard,
        this.expirationMonth,
        this.expirationYear,
        this.cvv
      );
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showError("There's an error, please check the red inputs");
      } else {
        var username = this.username;
        var password = this.password;
        var ccNumber = this.ccNumber;
        var firstNameOnCard = this.firstNameOnCard;
        var lastNameOnCard = this.lastNameOnCard;
        var expirationMonth = this.expirationMonth;
        var expirationYear = this.expirationYear;
        var cvv = this.cvv;
        await this.$store
          .dispatch("discoveryMigrate", {
            username,
            password,
            ccNumber,
            firstNameOnCard,
            lastNameOnCard,
            expirationMonth,
            expirationYear,
            cvv
          })
          .then(
            response => {
              console.log("response", response);
              this.showSuccess(
                "Congratulations! Your Quest account is all set. Login with your email () and password."
              );
              // Make sure we are not authenticated.
              this.$store.commit("CLEAR_SESSION");
              // Navigate to the web site for sign in.
              this.$router.push("properties");
            },
            () => {}
          )
          .catch(error => {
            console.log("error", error);
          });
      }
    }
  },

  beforeCreate() {
    console.log("beforeCreate())");
    this.$store.state.isLoginRequired = false;
  },

  beforeDestroy() {
    console.log("beforeDestroy()");
    this.$store.state.isLoginRequired = true;
  }
};
</script>

<style>
</style>
